import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  chip: {
    marginRight: spacing(1),
    background: colors.controls.chips.enabled.fill,
    color: colors.controls.chips.enabled.text,
    padding: `${spacing(0.5)}px ${spacing(1) + 3}px ${spacing(0.5)}px ${spacing(2)}px`,
    height: 'auto',
    '&:hover': {
      cursor: 'pointer',
      color: colors.controls.chips.hovered.text,
      backgroundColor: colors.controls.chips.hovered.fill,
    },
  },
  chipLabel: {
    padding: 0,
    paddingRight: spacing(1),
  },
  deleteIcon: {
    margin: 0,
    height: 'auto',
    width: 'auto',
  },
  disabled: {
    background: colors.controls.chips.disabled.fill,
    color: colors.controls.chips.disabled.text,
  },
});

export default styles;
